import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGamepadControlsLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGamepadControlsLeft"><Path d="M8 2H16V7.06066L12 11.0607L8 7.06066V2Z" fill="currentColor"/><Path d="M16.9393 8H22V16H16.9393L12.9393 12L16.9393 8Z" fill="currentColor"/><Path d="M16 16.9393V22H8V16.9393L12 12.9393L16 16.9393Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 8V16H7.06066L11.0607 12L7.06066 8H2ZM6.43934 14.5H3.5L3.5 9.5H6.43934L8.93934 12L6.43934 14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGamepadControlsLeft;
